import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { SettingsService } from '@core';
import { AuthService, IdleService } from '@core/authentication';

import { IconService } from '@shared/services/icons.service';
import { VersionCheckerService } from '@shared/services/version-checker.service';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private settings: SettingsService,
    private iconService: IconService,
    private versionService: VersionCheckerService,
    private authService: AuthService,
    private idleService: IdleService
  ) {}

  ngOnInit() {
    this.settings.setDirection();
    const options = this.settings.getOptions();
    options.theme = `dark`;
    this.settings.setOptions(options);
    this.settings.setTheme();
    this.iconService.registerIcons();

    // Setup idle tracking based on authentication state
    this.setupIdleTracking();
  }

  ngAfterViewInit() {
    this.versionService.runChecking();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.idleService.stopTracking();
  }

  private setupIdleTracking(): void {
    // Start tracking if user is already authenticated
    if (this.authService.check()) {
      this.idleService.startTracking();
    }

    // Listen to auth changes to start/stop tracking
    const authSub = this.authService.change().subscribe(() => {
      if (this.authService.check()) {
        this.idleService.startTracking();
      } else {
        this.idleService.stopTracking();
      }
    });

    this.subscriptions.push(authSub);
  }
}
